/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_XY_LIVE", "566")
  

// 接口文档

  
    
export interface IAPI76994ResListItemInputUserObj {
  
  /** 头像 */
  headImg?: string;
  
  /** 昵称 */
  nickName?: string;
  
  /** 真名 */
  realName?: string;
  
  /** 用户id */
  userId?: string;
  
};
    
  
    
export interface IAPI76994ResListItemOutputUserObj {
  
  /** 头像 */
  headImg?: string;
  
  /** 昵称 */
  nickName?: string;
  
  /** 真名 */
  realName?: string;
  
  /** 用户id */
  userId?: string;
  
};
    
  
    
export type IAPI76994ResListItemExtDataResponseObjDataObj = {};
    
  
    
export interface IAPI76994ResListItemExtDataResponseObj {
  
  /** 数据类型 */
  dataType?: string;
  
  /** 数据 ,Object */
  data?: IAPI76994ResListItemExtDataResponseObjDataObj;
  
};
    
  
    
export interface IAPI76994ResListItem {
  
  /** 主键 */
  id?: number;
  
  /** 应用实例编码 */
  appInstanceCode?: string;
  
  /** 会话编号 */
  sessionCode?: string;
  
  /** 输入用户信息 ,ChatUserResponse */
  inputUser?: IAPI76994ResListItemInputUserObj;
  
  /** 输出用户信息 ,ChatUserResponse */
  outputUser?: IAPI76994ResListItemOutputUserObj;
  
  /** 输入内容 */
  inputContent?: string;
  
  /** 输出内容 */
  outputContent?: string;
  
  /** 输入时间 */
  inputTime?: any;
  
  /** 输出时间 */
  outputTime?: any;
  
  /** 扩展信息 ,ExtDataResponse */
  extDataResponse?: IAPI76994ResListItemExtDataResponseObj;
  
};
    
  



export interface API76994Req {
  
  /** 会话code */
  sessionCode?: string;
    
  /**  */
  pageSize?: string;
    
  /**  */
  pageIndex?: string;
    
  /**  */
  rowId?: string;
    
  /**  */
  jumpType?: string;
    
  /**  */
  searchCount?: string;
    
  /**  */
  orderObjects?: string;
    
};



export interface API76994Res {
  /** T  */
  list?: IAPI76994ResListItem[];
  /**   */
  totalNumber?: number;
  /**   */
  totalPage?: number;
  /**   */
  rowId?: string;
  /**   */
  hasNext?: boolean;
  /**   */
  pageSize?: number;
  /**   */
  pageIndex?: number;
  
};


// 接口函数 76994 分页查询聊天记录

export interface IUseGetAPI76994Return {
  /** 分页查询聊天记录: 接口请求状态 */
  isAPI76994Loading: boolean;
  /** 分页查询聊天记录: 接口请求返回数据 */
  dataAPI76994: API76994Res;
  /**  分页查询聊天记录: 接口数据请求方法 */
  fetchAPI76994Data: (inputs: API76994Req, config?: YWRequestConfig) => Promise<API76994Res>;
  /** 分页查询聊天记录: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI76994 = ():IUseGetAPI76994Return => {
  let isMount = true;
  const [isAPI76994Loading, setIsAPI76994Loading] = useState(false);
  const [dataAPI76994, setDataAPI76994] = useState<API76994Res>({} as API76994Res);
  const requestUrl = `${basePath}/yoaichat-admin/chat/record/page`;

  const fetchAPI76994Data = async (inputs: API76994Req, config?: YWRequestConfig): Promise<API76994Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API76994Req>) || {}) as API76994Req;
    
  
    if ( isMount ) {
      setIsAPI76994Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API76994Res>(`${basePath}/yoaichat-admin/chat/record/page?${querystring.stringify(params as any)}`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI76994(res || {} as API76994Res);
        setIsAPI76994Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI76994Loading(false);
      }
      return false as unknown as API76994Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI76994Loading,
    dataAPI76994,
    fetchAPI76994Data,
    requestUrl,
  }
}

